import OrderPreferences from './OrderPreferences.component';

export default OrderPreferences;
